import React, {useContext} from 'react'
import MUIDataTable from "mui-datatables";
import {createMuiTheme, MuiThemeProvider} from '@material-ui/core/styles';
import { colors } from '../../shared/colors';
import AppButton from "../Common/AppButton";
import messages from "./messages";
import PriorAuthorizationContext from "../../contexts/PriorAuthorization/PriorAuthorization.context";
import { TableCell, TableRow } from "@material-ui/core";
import { styled } from '@material-ui/styles';

export default function SearchResults(props){
    const { data, title, operationType, setModal } = props
    const {tableActionButton: {[operationType]: actionProps}, clickText} = messages;
    const {setState, authNumber, priorAuthStatusFromView,  fields} = useContext(PriorAuthorizationContext);

    const isAdvancedSearch = fields.beneficiaryDOB.value
                            || fields.beneficiaryID.value
                            || fields.beneficiaryLastName.value ? true : false

    const getCategories = () => {
        let categories = [
            { name: 'authNumber', label: 'Authorization #' },
            { name: 'priorAuthStatus', label: 'PA Status' },
            { name: 'dispositionNote', label: 'PA Note'},
            { name: 'beneficiaryLastName', label: 'Last Name' },
            { name: 'beneficiaryFirstName', label: 'First Name' },
            { name: 'beneficiaryDOB', label: 'Date of Birth' },
            { name: 'drugTitle', label: 'Drug Name/Strength' },
            { name: 'resendTooltip', label: 'PA Response' },
            { name: 'action', label: 'Action'}
        ]
        // if advanced search
        if(!authNumber){
            categories.splice(3, 0, {name: 'requestBeginDate', label: 'PA Start Date' })
            categories.splice(4, 0, {name: 'requestEndDate', label: 'PA End Date' })
        }
        return categories
    }

    const categories = getCategories()
    const isRecordValid = record => record.errorMessage === null ||
                                    record.errorMessage === undefined
    const transformedData = []
    data.forEach( record => {
        if(isRecordValid(record)){
            record.drugTitle = `${record.drugName}/${record.drugStrength}`
            transformedData.push(record)
        }
    })

    const options = {
        setCellHeaderProps: () => ({
            style: {
                backgroundColor: colors.dhcsBlue,
            }
        })
    }
    const makeResendTooltip = row => {

        const handleOpen = () => {
            setModal( prev => ({
                ...prev,
                title: row.resendVerbiage,
                open: true
            }))
        }

        return (
            <a href={'#'} rel="noopener noreferrer"  onClick={handleOpen}>{clickText}</a>
        )
    }
    const shouldShowAction = row => {
        if (operationType === 'inquiry') {
            return isRecordValid(row) && row.authNumber
        }
        else {
            // Check if Auth number starts with web and PA status is `IN PROGRESS`
            return (
              isRecordValid(row) &&
              row.authNumber &&
              row.authNumber.toLowerCase().startsWith("web") &&
              row.priorAuthStatus &&
              row.priorAuthStatus.toLowerCase().includes("in progress")
            );
        }
    }
    const columns = categories.map( col => ({...col, options}) );

    const finalData = transformedData.map( row => {
        actionProps.onClick = () => {
            setState( prev => {
                console.log(prev)
                return {
                  ...prev,
                  operation: operationType,
                  authNumber: row.authNumber,
                  priorAuthStatusFromView: row.priorAuthStatus,
                  inquiry: {
                    ...prev.inquiry,
                    view: "summary",
                    advancedSearch: isAdvancedSearch,
                    requestId: row.requestId,
                    resendVerbiage: row.resendVerbiage,
                  },
                };
            })
        }

        return {
          ...row,
          authNumber: row.authNumber || row.requestId,
          action: shouldShowAction(row) && <AppButton {...actionProps} />,
          resendTooltip: row.resendVerbiage ? makeResendTooltip(row) : "",
          requestBeginDate:
            row.priorAuthStatus &&
            row.priorAuthStatus.toLowerCase().includes("approved")
              ? row.requestBeginDate
              : "N/A",
          requestEndDate:
            row.priorAuthStatus &&
            row.priorAuthStatus.toLowerCase().includes("approved")
              ? row.requestEndDate
              : "N/A",
        };
    });

    const StyledTableRow = styled(TableRow)(({ theme }) => ({
        '&:nth-of-type(even)': {
          backgroundColor: colors.dhcsAccentGray,
        }
      }));

    const tableOptions = {
        print: false,
        download: false,
        viewColumns: false,
        filter: false,
        search: false,
        sort: false,
        selectableRows: 'none',
        responsive: 'scrollMaxHeight',
        customRowRender: (data) => {
            return (
              <StyledTableRow>
                {data.map(label => {
                    return(
                        <TableCell>{label}</TableCell>
                    )
                })}
              </StyledTableRow>
            );
          },
    }
    const getMuiTheme = () => createMuiTheme({
        overrides: {
            MUIDataTableHeadCell: {
                root: {
                    fontSize: "1rem",
                    fontWeight: "bold",
                    color: 'white',
                },
            },
            MUIDataTableBodyCell: {
                root: {
                    wordBreak: 'break-word',
                    maxWidth: '25ch'
                }
            }
        }
    })
    return(
        <MuiThemeProvider theme={getMuiTheme()}>
            <MUIDataTable
            title={title}
            data={finalData}
            columns={columns}
            options={tableOptions}
            />
        </MuiThemeProvider>
    )
}
